import { createFileRoute } from "@tanstack/react-router";
import { getCmsLegalPage } from "@/lib/cms/website.functions";
import { LegalPageView, legalHead } from "@/components/cms/LegalPageView";

const SLUG = "terms-and-conditions";
const FALLBACK = "Terms & Conditions";

export const Route = createFileRoute("/terms-and-conditions")({
  loader: () => getCmsLegalPage({ data: { slug: SLUG } }),
  head: ({ loaderData }) => legalHead(loaderData ?? null, FALLBACK, `/${SLUG}`),
  component: () => <LegalPageView page={Route.useLoaderData()} fallbackTitle={FALLBACK} />,
});
